module.exports = __webpack_public_path__ + "img/citation-audit.67ec96cf.png";